const audioTypes = {
  FILE: 'file',
  URL: 'url',
}

export default audioTypes
